import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ChevronDown.svg",
  "use": "ChevronDown.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ChevronDown.svg\"><path d=\"M33.4079,43.43a1.9992,1.9992,0,0,1-2.829,0L15.5744,28.4178a2.0009,2.0009,0,1,1,2.8289-2.83l13.59,13.5968,13.59-13.5968a2.001,2.001,0,1,1,2.8291,2.83Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol